<button class="button-loader" tabindex="0" type="button" aria-label="Interact in 3D" type="button">
  <div class="button-loader__button">
    <img class="button-loader__3d-arrow" src="assets/images/widget/loading_experience/interact-in-3d-arrow.svg" alt="Interact in 3D">
    <div class="button-loader__label">Interact in 3D</div>
  </div>
</button>